import { ArticleCurdVm } from "../../models/view/article-curd.vm";

export class GetArticleParamCommand {
    constructor(public getArticleParam: ArticleCurdVm) {
    }
}
